import React, { Component } from 'react'
import { Provider } from '../context'
import decode from 'jwt-decode'
import { setItem, getItem, removeItem, clear } from '@/storage'

// Helper to get URL parameters
const getQueryParam = (param) => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(param);
};

// Helper to clean URL parameters
const cleanUrlParams = () => {
  const url = new URL(window.location);
  url.searchParams.delete('token');
  url.searchParams.delete('id');
  url.searchParams.delete('username');
  url.searchParams.delete('email');
  url.searchParams.delete('role');
  window.history.replaceState({}, document.title, url.toString());
};

export const isAuthenticated = () => {
  const token = getItem('Authorization_token')

  try {
    const { exp } = decode(token)
    const cur = Math.round(new Date().getTime() / 1000)
    if (cur - exp >= 0 || exp - cur <= 30) {
      clear()
      return false
    }
  } catch (err) {
    return false
  }

  return true
}

class AuthProvider extends Component {
  state = {
    authStatus: isAuthenticated()
  }

  login = ({ token, accountType, loginId }) => {
    let at =accountType=='SA' ? accountType : 'PA';
    setItem('Authorization_token', token)
    setItem('Account_type', at)
    setItem('Login_id', loginId)
    this.setState({ authStatus: true })
  }

  // NEW: Token-based authentication from URL
  tokenLogin = (token) => {
    try {
      const payload = decode(token);
      let accountType = payload.roles=='SA' ? payload.roles : 'PA';
      // Check token expiration
      const currentTime = Math.round(Date.now() / 1000);
      if (payload.exp && currentTime > payload.exp) {
        console.error('Token has expired');
        return false;
      }

      // Set token in storage
      setItem('Authorization_token', token);
      setItem('Account_type', accountType);
      setItem('Login_id', payload.loginId);
      
      return true;
    } catch (error) {
      console.error('Token processing failed:', error);
      return false;
    }
  };

  logout = () => {
    removeItem('Authorization_token')
    removeItem('Account_type')
    removeItem('Login_id')

    // NEW: Notify Service Worker to clear caches
    if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
      navigator.serviceWorker.controller.postMessage({ type: 'CLEAR_CACHE' });
    }

    this.setState({ authStatus: false })
  }

  componentDidMount() {
    // Handle token from URL only if not already authenticated
    if (!this.state.authStatus) {
      const token = getQueryParam('token');
      
      if (token) {
        const loginSuccess = this.tokenLogin(token);
        
        if (loginSuccess) {
          this.setState({ authStatus: true });
        }
        
        // Store user details from URL parameters in localStorage
        const userId = getQueryParam('id');
        const userName = getQueryParam('username');
        const userEmail = getQueryParam('email');
        const userRole = getQueryParam('role');
        
        if (userId) setItem('id', userId);
        if (userName) setItem('username', userName);
        if (userEmail) setItem('email', userEmail);
        if (userRole) setItem('role', userRole);
        
        // Clean URL after processing
        cleanUrlParams();
      }
    }
  }
  
  render() {
    const value = {
      ...this.state,
      login: this.login,
      logout: this.logout
    }

    return <Provider value={value}>{this.props.children}</Provider>
  }
}

export default AuthProvider



// WEBPACK FOOTER //
// ./src/auth/components/AuthProvider.jsx